import { render, staticRenderFns } from "./KYC.vue?vue&type=template&id=63c0a130&scoped=true&"
import script from "./KYC.vue?vue&type=script&lang=js&"
export * from "./KYC.vue?vue&type=script&lang=js&"
import style0 from "./KYC.vue?vue&type=style&index=0&id=63c0a130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c0a130",
  null
  
)

export default component.exports